{
  "processing": "Traitement de la vérification...",
  "loadingIframe": "Chargement de la vérification d'identité...",
  "issueTitle": "Problème de vérification d'identité",
  "notConfigured": "La vérification d'identité n'est pas correctement configurée pour cet entrepôt.",
  "notSuccessful": "La vérification d'identité n'a pas abouti. Veuillez réessayer ou contacter l'entrepôt.",
  "couldNotCompleteProceed": "La vérification d'identité n'a pas pu être complétée, mais vous pouvez poursuivre l'enregistrement.",
  "processFailed": "Échec du traitement de la vérification d'identité. Veuillez réessayer.",
  "processingFailedProceed": "Le traitement de la vérification d'identité a échoué, mais vous pouvez poursuivre l'enregistrement.",
  "genericError": "Une erreur s'est produite lors de la vérification d'identité. Veuillez réessayer.",
  "issueProceed": "La vérification d'identité a rencontré un problème, mais vous pouvez poursuivre l'enregistrement.",
  "requiredTryAgain": "La vérification d'identité est requise pour finaliser l'enregistrement. Veuillez réessayer.",
  "checkInFailedTitle": "Enregistrement impossible",
  "checkInFailedMessage": "Votre pièce d'identité n'a pas pu être validée"
}
